import { readDepartmentBasedAssignments } from "@/schemas/departmentBasedAssignments";
import { readRoleBasedAssignments } from "@/schemas/roleBasedAssignments";
import { z } from "@/zod";

export const roleBasedAssignmentsFormSchema = z.object({
  entries: z.record(z.string(), readRoleBasedAssignments),
});

export const departmentBasedAssignmentsFormSchema = z.object({
  entries: z.record(z.string(), readDepartmentBasedAssignments),
});
